import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { useFreecodeContextRun } from 'hooks/useContext';
import services from 'api/services';
const { InputService } = services;

export default function useTestAutoSave() {
  const { ticketId } = useParams();

  const { codeSolRef, languageRef } = useFreecodeContextRun();

  const autoSaveIntervalRef = useRef(undefined);

  useEffect(() => {
    const performAutoSave = async () => {
      try {
        await InputService.autoSaveTicketCode({
          ticket: ticketId,
          code: codeSolRef.current,
          language: languageRef.current,
        });
      } catch (error) {
        console.error('Auto save error:', error);
      }
    };
    clearInterval(autoSaveIntervalRef.current);
    autoSaveIntervalRef.current = setInterval(performAutoSave, 5000);
    return () => {
      clearInterval(autoSaveIntervalRef.current);
    };
  }, [ticketId, codeSolRef, languageRef]);
}
